import { createFileRoute } from '@tanstack/react-router';
import TemplateEditPage from '@/pages/(protected)/workspaces/[workspaceId]/templates/template-edit';

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/templates/$templateId/edit'
)({
  component: TemplateEditPage,
});
